
import React, { useContext } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../app/store/root";
import { getColorEstatusEmbarque, getFormatDate } from "../../app/util/util";

const InfoGeneralEmbarque = () => {
    const rootStore = useContext(RootStoreContext);
    const { entity } = rootStore.embarqueStore
    
    return (
        <Box>
            <Typography variant="h6" color={"primary.main"}>Información general</Typography>
            <Grid container direction={"row"} spacing={1} mt={1}>
                <Grid item sm={4} container direction={"column"}>
                    <Typography variant="labelBold">No. de carta porte</Typography>
                    <Typography variant="subtitle">{entity.numeroCartaPorte}</Typography>
                </Grid>
                <Grid item sm={4} container direction={"column"}>
                    <Typography variant="labelBold">Fecha de creación del embarque</Typography>
                    <Typography variant="subtitle">{getFormatDate(entity.fechaCreo)}</Typography>
                </Grid>
                <Grid item sm={4} container direction={"column"}>
                    <Typography variant="labelBold">Último estatus</Typography>
                    <Typography variant="estatus" color={getColorEstatusEmbarque(entity.estatus)}>{entity.estatus}</Typography>
                    <Typography variant="subtitle">{getFormatDate(entity.fechaUltimoEstatus, 'dd/MM/yyyy')}</Typography>
                </Grid>
                <Grid item sm={12} container direction={"column"}>
                    <Typography variant="labelBold">Detalles del embarque</Typography>
                    <Typography variant="subtitle">{entity.comentario}</Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

export default observer(InfoGeneralEmbarque)